<mat-form-field appearance="fill" class="date-input-box">
  <mat-label>MM/DD/YYYY</mat-label>
  <input matInput placeholder="" mask="00/00/0000" autocomplete="off" [errorStateMatcher]="errorStateMatcher" [formControl]="dateControl" (input)="onInput($event)" (focus)="onFocus()" (blur)="onBlur()" />
  @for (errorType of errorTypes; track errorType; let i = $index) {
    <mat-error data-cy="date-error">
      @if (getErrorMessage(errorType).showError) {
        <span class="pb-3">
          <i class="icon-warning_white"></i>
          {{ getErrorMessage(errorType).errorText }}
        </span>
      }
    </mat-error>
  }
</mat-form-field>
